'use strict';

var _defineProperty = require("/Users/federicoperalta/Documents/projects/litebox/molo-online-booking/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isIp = require('is-ip');

var defaults = {
  timeout: 5000
};
var urls = {
  v4: 'https://ipv4.icanhazip.com/',
  v6: 'https://ipv6.icanhazip.com/'
};

var queryHttps = function queryHttps(version, options) {
  var xhr;
  var promise = new Promise(function (resolve, reject) {
    var doReject = function doReject() {
      reject(new Error('Couldn\'t find your IP'));
    };

    xhr = new XMLHttpRequest();
    xhr.addEventListener('error', doReject, {
      once: true
    });
    xhr.addEventListener('timeout', doReject, {
      once: true
    });
    xhr.addEventListener('load', function () {
      var ip = xhr.responseText.trim();

      if (!ip || !isIp[version](ip)) {
        doReject();
      }

      resolve(ip);
    }, {
      once: true
    });
    xhr.open('GET', urls[version]);
    xhr.timeout = options.timeout;
    xhr.send();
  });

  promise.cancel = function () {
    xhr.abort();
  };

  return promise;
};

module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread({}, defaults, {}, options));
};

module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread({}, defaults, {}, options));
};